﻿export function setupFleetNewsAccount()
{
    var startState = $("[name='Input.IsFleetDecisionMaker']:checked").val();
    if (startState == "true") {
        $("[data-fleet-options]").show();
    } else {
        $("[data-fleet-options]").hide();
    }

    $(function () {

        $("[name='Input.IsFleetDecisionMaker']").click(function () {
            if ($(this).is(':checked')) {
                $("[data-fleet-options]").show();
            } else {
                $("[data-fleet-options]").hide();
            }
        });
    });

}